<template>
  <div class="flex h-screen bg-gray-200">
    <Sidebar v-bind:lang="showLang[selectLang]" v-bind:usLang="selectLang" v-bind:guideStepMenu="nextStepMenuStatus" v-bind:guideOpenTeachingAgain="openTeachingAgain" v-bind:getChangeLinkType="getChangeLinkType" v-bind:useFbCustomizeStatusForView="useFbCustomizeStatusForView" @menuCheck="doMenuCheck" @firstLoginStatus="doFirstLoginStatus" @fbNum="transmitFbNum" @tiktokNum="transmitTiktokNum" @sidebarFbCustomize="doSidebarFbCustomize" @closeForTeaching="doCloseForTeaching"/>
    <router-view v-bind:newTeaching="newTeaching" v-bind:getFirstLoginStatus="getFirstLoginStatus" v-bind:getTransmitFbNum="getTransmitFbNum" v-bind:getTransmitTiktokNum="getTransmitTiktokNum" v-bind:useFbCustomize="useFbCustomize" v-bind:closeForTeaching="closeForTeaching" @childLang="useLang" @nextStep="nextStepMenu" @childHomeOpenFirstLogin="homeOpenFirstLogin" @childSetChangeLinkType="setChangeLinkType" @canUseFbCustomize="canUseFbCustomize"/>
  </div>
</template>

<script>
  import { createApp } from 'vue'
  import Sidebar from '@/components/Sidebar.vue'
  import lang from '@/language/lang.json'

  export default {
    components: {
      Sidebar,
    },
    data() {
      return {
        selectLang: 'zh-TW',
        nextStepMenuStatus: -1,
        getFirstLoginStatus: [],
        getTransmitFbNum: 0,
        getTransmitTiktokNum: 0,
        getChangeLinkType: 'f',
        showLang: lang,
        newTeaching: 'false',
        openTeachingAgain: 'N',
        useFbCustomize: false,
        useFbCustomizeStatusForView: null,
        closeForTeaching: null,
      }
    },
    methods: {
      useLang(v){
        console.log('app useLang');
        console.log(v);

        this.selectLang = v
        console.log(this.showLang[this.selectLang]);
      },
      doMenuCheck(v){
        this.newTeaching = v;
      },
      doFirstLoginStatus(v){
        console.log('doFirstLoginStatus');
        console.log(v);
        this.getFirstLoginStatus = v;
      },
      transmitFbNum(v){
        console.log('transmitFbNum');
        console.log(v);
        this.getTransmitFbNum = v;
      },
      transmitTiktokNum(v){
        console.log('transmitTiktokNum');
        console.log(v);
        this.getTransmitTiktokNum = v;
      },
      nextStepMenu(v) {
        console.log('nextStepMenu');
        console.log(v);
        console.log('b nextStepMenuStatus');
        console.log(this.nextStepMenuStatus);
        this.nextStepMenuStatus = v
        console.log('a nextStepMenuStatus');
        console.log(this.nextStepMenuStatus);
      },
      homeOpenFirstLogin(v){
        console.log('homeOpenFirstLogin');
        console.log(v);

        this.openTeachingAgain = v;
      },
      setChangeLinkType(v){
        console.log('app setChangeLinkType');
        this.getChangeLinkType = v;
      },
      doSidebarFbCustomize(v){
        console.log('doSidebarFbCustomize', v);
        this.useFbCustomize = v
      },
      canUseFbCustomize(v){
        console.log('canUseFbCustomize', v);
        this.useFbCustomizeStatusForView = v;
      },
      doCloseForTeaching(){
        this.closeForTeaching = false;
      }
    }
  }
</script>